import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import floor from 'lodash/floor';
import { Badge } from 'reactstrap';

import { currencyCode } from 'Helpers/Geo/data';
import Price from 'Containers/Utility/Price/Price';
import SpecialFormattedNumber from 'Containers/Utility/Price/SpecialFormattedNumber';


export default function ProductDiscountPrice(
  { price, hideDiscount, currentDiscount },
) {
  let showDiscount = currentDiscount.percent > 0;
  let youSave = {};
  let savingAmount = 0;

  if (hideDiscount) {
    showDiscount = false;
  }

  youSave = {
    [currencyCode]:
      floor(
        price[currencyCode] - Math.floor((price[currencyCode] * (1 - currentDiscount.percent))), 2,
      ),
  };

  savingAmount = youSave[currencyCode];

  return (
    <React.Fragment>
      <div className="PriceContainer">
        <div className="PriceContainer__price">
          <b>
            <Price
              showZero
              price={price}
              discount={currentDiscount.percent}
            />
          </b>
        </div>
        {showDiscount &&
          <div className="PriceContainer__wasPrice">
            <Price
              price={price}
            />
          </div>
        }
        {/* eslint-disable react/style-prop-object */}
        {showDiscount &&
          <div className="PriceContainer__savingPercentage">
            <React.Fragment> -<SpecialFormattedNumber value={currentDiscount.percent} style="percent" />  </React.Fragment>
          </div>
        }
      </div>
      {savingAmount > 0 && currentDiscount.best_ever && showDiscount &&
        <div>
          <Badge color="secondary"><FormattedMessage id="productdiscountprice.besteversaving" defaultMessage="Best Ever Saving" /></Badge>
        </div>
      }
      {savingAmount === 0 && showDiscount && currentDiscount.best_ever &&
        <div>
          <Badge color="secondary"><FormattedMessage id="productdiscountprice.besteversaving" defaultMessage="Best Ever Saving" /></Badge>
        </div>
      }
    </React.Fragment>
  );
}

ProductDiscountPrice.propTypes = {
  price: PropTypes.shape({}).isRequired,
  hideDiscount: PropTypes.bool,
  currentDiscount: PropTypes.shape({}).isRequired,
};

ProductDiscountPrice.defaultProps = {
  hideDiscount: false,
};
